<label class="input-wrapper px-2 rounded-md border h-10 bg-white flex gap-1 z-[1] relative items-center">
  <ng-content select="[ctrPreffix]"></ng-content>
  <div class="relative flex-1 self-stretch">
    <select
      class="input outline-none w-full text-sm text-ctr bg-transparent"
      [(ngModel)]="inputValue"
      (blur)="onBlur()"
      (ngModelChange)="changeValue($event)"
    >
      @if (options) {
        @for (option of options.toArray(); track $index) {
          <option [value]="option.value">
            <ng-container [ngTemplateOutlet]="option.template"></ng-container>
          </option>
        }
      }
    </select>
    <span class="absolute -z-10 label" [class.content]="inputValue">{{ label }}</span>
  </div>
  <ng-content select="[ctrSuffix]"></ng-content>
</label>
